module.exports = __webpack_public_path__ + "static/media/location.9c51ead5.png";